import { render } from "./DeactivatedAccounts.vue?vue&type=template&id=93ce9dbe"
import script from "./DeactivatedAccounts.vue?vue&type=script&lang=js"
export * from "./DeactivatedAccounts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__